export const environment = {
  production: false,
  urlBE: '/api/',
};
